import User from '../models/user.model'

let storeContent = utils.generateStore({
   User,
   users: [],
   showChangePassword: false,
   showEdit: false,
   selectedUser: null,
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async changePassword(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_, user = await $session.get('user')

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "auth",
                  action: "change_password",
                  data: {
                     email: user.email,
                     password: data.password,
                     newPassword: data.confirmPassword,
                  },
                  meta_data: {}
               });

               $notify('success', 'Password Changed', `User password was successfully updated.`)
               setTimeout(() => {
                  window.location.href = '/';
               }, 2000);
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async editUser(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "auth",
                  action: "edit_user",
                  data: {
                     names: data.firstName + ' ' + data.lastName,
                     role: data.userType,
                     id: ctx.getters.selectedUser._id,
                  },
                  meta_data: {}
               })

               ctx.commit('showEdit', false)
               await ctx.dispatch('fetchUsers')
               $notify('success', 'User Updated', `User ${data.firstName} ${data.lastName} successfully updated.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteUser(ctx,id) {
         try {
            ctx.commit('loading', true)

            await api.fetchEndpointSecure({
               resource: "auth",
               action: "delete_user",
               data: {
                  id,
               },
               meta_data: {}
            })

            await ctx.dispatch('fetchUsers')
            $notify('success', 'User Deleted', `User successfully deleted.`)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async addUser(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "auth",
                  action: "create_user",
                  data: {
                     names: data.firstName + ' ' + data.lastName,
                     email: data.email,
                     password: data.confirmPassword,
                     role: data.userType,
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchUsers')
               $notify('success', 'User Created', `User ${data.firstName} ${data.lastName} successfully created.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchUsers(ctx){
         try {
            ctx.commit('show', false)
            let res = await api.fetchEndpointSecure({
               resource: "auth",
               action: "get_users",
               data: {},
               meta_data: {}
            })
            ctx.commit('users',res.result.users)

            EventBus.$emit('loader:show',false)
         } catch (err) {
            throw err
         }
      },
   }
};